import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import type { StorageProvider } from '@cli-types/next-adapter/init.js'

export function addStorageIntegration(
  integrations: BetterstartIntegrationId[],
  provider: StorageProvider
): BetterstartIntegrationId[] {
  if (provider === 'local' || integrations.includes(provider)) {
    return integrations
  }

  return [...integrations, provider]
}
